function getImages(product) {

  const variants = product.variants
  const images = product.images

  let variant_options = {}

  // build a variant options reference - for each variant, get the options used

  for (const variant of variants) {
      variant_options[variant.id] = {}

      if (variant.option1) {
          variant_options[variant.id]['option1'] = variant.option1
      }

      if (variant.option2) {
          variant_options[variant.id]['option2'] = variant.option2
      }
      
      if (variant.option3) {
          variant_options[variant.id]['option3'] = variant.option3
      }
  }

  let all_images = []
  let variant_ids = []


  for (const image of images) {

      if (image.variant_ids.length > 0) {
          variant_ids = image.variant_ids
      } else {
          variant_ids = [ variants[0].id ]
      }

      for (const variant_id of variant_ids) {
          const image_obj = {
              'src': image.src,
              'alt': image.alt,
              'pos': image.position,
              'variant_id': variant_id,
              'option1': variant_options[variant_id].option1,
              'option2': variant_options[variant_id].option2,
              'option3': variant_options[variant_id].option3
          }
          all_images.push(image_obj)
      }
      
  }

  return all_images;

}

(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
      module.exports = factory();
  } else {
      root.ImageZoom = factory();
  }
}(this, function () {
  /**
   * @param {Object} container DOM element, which contains an image to be zoomed (required)
   * @param {Object} options js-image-zoom options (required)
   * **width** (number) - width of the source image (optional)
   * **height** (number) - height of the source image (optional).
   * **zoomWidth** (number) - width of the zoomed image. Zoomed image height equals source image height (optional)
   * **img** (string) - url of the source image. Provided if container does not contain img element as a tag (optional)
   * **scale** (number) - zoom scale. if not provided, scale is calculated as natural image size / image size, provided in params (optional if zoomWidth param is provided)
   * **offset** (object) - {vertical: number, horizontal: number}. Zoomed image offset (optional)
   * **zoomContainer** (node) - DOM node reference where zoomedImage will be appended to (default to the container element of image)
   * **zoomStyle** (string) - custom style applied to the zoomed image (i.e. 'opacity: 0.1;background-color: white;')
   * **zoomPosition** (string) - position of zoomed image. It can be:  `top`, `left`, `bottom`, `original` or the default `right`.
   * **zoomLensStyle** (string) custom style applied to to zoom lents (i.e. 'opacity: 0.1;background-color: white;')
   */
  return function ImageZoom(container, opts) {
      "use strict";
      var options = opts;
      if (!container) {
          return;
      }
      var data = {
          sourceImg: {
              element: null,
              width: 0,
              height: 0,
              naturalWidth: 0,
              naturalHeight: 0
          },
          zoomedImgOffset: {
              vertical: 0,
              horizontal: 0
          },
          zoomedImg: {
              element: null,
              width: 0,
              height: 0
          },
          zoomLens: {
              element: null,
              width: 0,
              height: 0
          }
      };

      var div = document.createElement('div');
      var lensDiv = document.createElement('div');
      var scaleX;
      var scaleY;
      var offset;
      data.zoomedImgOffset = {
          vertical: options.offset && options.offset.vertical ? options.offset.vertical : 0,
          horizontal: options.offset && options.offset.horizontal ? options.offset.horizontal : 0
      };
      data.zoomPosition = options.zoomPosition || 'right';
      data.zoomContainer = (options.zoomContainer) ? options.zoomContainer : container;
      function getOffset(el) {
          if (el) {
              var elRect = el.getBoundingClientRect();
              return {left: elRect.left, top: elRect.top};
          }
          return {left: 0, top: 0};
      }

      function leftLimit(min) {
          return options.width - min;
      }

      function topLimit(min) {
          return options.height - min;
      }

      function getValue(val, min, max) {
          if (val < min) {
              return min;
          }
          if (val > max) {
              return max;
          }
          return val;
      }

      function getPosition(v, min, max) {
          var value = getValue(v, min, max);
          return value - min;
      }

      function zoomLensLeft(left) {
          var leftMin = data.zoomLens.width / 2;
          return getPosition(left, leftMin, leftLimit(leftMin));
      }

      function zoomLensTop(top) {
          var topMin = data.zoomLens.height / 2;
          return getPosition(top, topMin, topLimit(topMin));
      }

      function setZoomedImgSize(options, data) {
          if (options.scale) {
              data.zoomedImg.element.style.width = options.width * options.scale + 'px';
              data.zoomedImg.element.style.height = options.height * options.scale + 'px';
          } else if (options.zoomWidth) {
              data.zoomedImg.element.style.width = options.zoomWidth + 'px';
              data.zoomedImg.element.style.height = data.sourceImg.element.style.height;
          } else {
              data.zoomedImg.element.style.width = '100%';
              data.zoomedImg.element.style.height = '100%';
          }
      }

      function onSourceImgLoad() {
          // use height determined by browser if height is not set in options
          options.height = options.height || data.sourceImg.element.height;
          data.sourceImg.element.style.height = options.fillContainer ? '100%': options.height + 'px';

          // use width determined by browser if width is not set in options
          options.width =  options.width || data.sourceImg.element.width;
          data.sourceImg.element.style.width = options.fillContainer ? '100%': options.width + 'px';

          setZoomedImgSize(options, data);

          data.sourceImg.naturalWidth = data.sourceImg.element.naturalWidth;
          data.sourceImg.naturalHeight = data.sourceImg.element.naturalHeight;
          data.zoomedImg.element.style.backgroundSize = data.sourceImg.naturalWidth + 'px ' + data.sourceImg.naturalHeight + 'px';

          if (options.zoomStyle) {
              data.zoomedImg.element.style.cssText += options.zoomStyle;
          }
          if (options.zoomLensStyle) {
              data.zoomLens.element.style.cssText += options.zoomLensStyle;
          } else {
              data.zoomLens.element.style.background = 'white';
              data.zoomLens.element.style.opacity = '0.4';
          }

          scaleX = data.sourceImg.naturalWidth / options.width;
          scaleY = data.sourceImg.naturalHeight / options.height;
          offset = getOffset(data.sourceImg.element);

          // set zoomLens dimensions
          // if custom scale is set
          if (options.scale) {
              data.zoomLens.width = options.width / (data.sourceImg.naturalWidth / (options.width * options.scale));
              data.zoomLens.height = options.height / (data.sourceImg.naturalHeight / (options.height * options.scale));
          }

          // else if zoomWidth is set
          else if (options.zoomWidth) {
              data.zoomLens.width = options.zoomWidth / scaleX;
              data.zoomLens.height = options.height / scaleY;
          }

          // else read from the zoomedImg
          else {
              data.zoomedImg.element.style.display = 'block';
              data.zoomLens.width = data.zoomedImg.element.clientWidth / scaleX;
              data.zoomLens.height = data.zoomedImg.element.clientHeight / scaleY;
              data.zoomedImg.element.style.display = 'none';
          }

          data.zoomLens.element.style.position = 'absolute';
          data.zoomLens.element.style.width = data.zoomLens.width + 'px';
          data.zoomLens.element.style.height = data.zoomLens.height + 'px';
          data.zoomLens.element.pointerEvents = 'none';
      }

      function setup() {
          // create sourceImg element
          if (options.img) {
              var img = document.createElement('img');
              img.src = options.img;
              data.sourceImg.element = container.appendChild(img);
          }

          // or get sourceImg element from specified container
          else {
              data.sourceImg.element = container.children[0];

              // if sourceImg is not an img (might be a picture element), try to find one
              if (data.sourceImg.element.nodeName !== "IMG") {
                  data.sourceImg.element = data.sourceImg.element.querySelector('img');
              }
          }

          options = options || {};
          container.style.position = 'relative';
          data.sourceImg.element.style.width = options.fillContainer ? '100%' : options.width ? options.width + 'px' : 'auto';
          data.sourceImg.element.style.height = options.fillContainer ? '100%' : options.height ? options.height + 'px' : 'auto';

          data.zoomLens.element = container.appendChild(lensDiv);
          data.zoomLens.element.style.display = 'none';
          data.zoomLens.element.classList.add('js-image-zoom__zoomed-area');

          data.zoomedImg.element = data.zoomContainer.appendChild(div);
          data.zoomedImg.element.classList.add('js-image-zoom__zoomed-image');
          data.zoomedImg.element.style.backgroundImage = "url('" + data.sourceImg.element.src + "')";
          data.zoomedImg.element.style.backgroundRepeat = 'no-repeat';
          data.zoomedImg.element.style.display = 'none';

          switch (data.zoomPosition) {
              case 'left':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
                  data.zoomedImg.element.style.left = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
                  data.zoomedImg.element.style.transform = 'translateX(-100%)';
                  break;

              case 'top':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
                  data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
                  data.zoomedImg.element.style.transform = 'translate3d(-50%, -100%, 0)';
                  break;

              case 'bottom':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.bottom = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
                  data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
                  data.zoomedImg.element.style.transform = 'translate3d(-50%, 100%, 0)';
                  break;

              case 'original':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = '0px';
                  data.zoomedImg.element.style.left = '0px';
                  break;

              // Right Position
              default:
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
                  data.zoomedImg.element.style.right = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
                  data.zoomedImg.element.style.transform = 'translateX(100%)';
                  break;
          }


          // setup event listeners
          container.addEventListener('mousemove', events, false);
          container.addEventListener('mouseenter', events, false);
          container.addEventListener('mouseleave', events, false);
          data.zoomLens.element.addEventListener('mouseenter', events, false);
          data.zoomLens.element.addEventListener('mouseleave', events, false);
          window.addEventListener('scroll', events, false);

          return data;
      }

      function kill() {

          // remove event listeners
          container.removeEventListener('mousemove', events, false);
          container.removeEventListener('mouseenter', events, false);
          container.removeEventListener('mouseleave', events, false);
          data.zoomLens.element.removeEventListener('mouseenter', events, false);
          data.zoomLens.element.removeEventListener('mouseleave', events, false);
          window.removeEventListener('scroll', events, false);

          // remove dom nodes
          if (data.zoomLens && data.zoomedImg) {
              container.removeChild(data.zoomLens.element);
              data.zoomContainer.removeChild(data.zoomedImg.element);
          }

          if (options.img) {
              container.removeChild(data.sourceImg.element);
          } else {
              data.sourceImg.element.style.width = '';
              data.sourceImg.element.style.height = '';
          }

          return data;
      }

      var events = {
          handleEvent: function (event) {
              switch (event.type) {
                  case 'mousemove':
                      return this.handleMouseMove(event);
                  case 'mouseenter':
                      return this.handleMouseEnter(event);
                  case 'mouseleave':
                      return this.handleMouseLeave(event);
                  case 'scroll':
                      return this.handleScroll(event);
              }
          },
          handleMouseMove: function (event) {
              var offsetX;
              var offsetY;
              var backgroundTop;
              var backgroundRight;
              var backgroundPosition;
              if (offset) {
                  offsetX = zoomLensLeft(event.clientX - offset.left);
                  offsetY = zoomLensTop(event.clientY - offset.top);
                  backgroundTop = offsetX * scaleX;
                  backgroundRight = offsetY * scaleY;
                  backgroundPosition = '-' + backgroundTop + 'px ' + '-' + backgroundRight + 'px';
                  data.zoomedImg.element.style.backgroundPosition = backgroundPosition;
                  data.zoomLens.element.style.cssText += 'transform:' + 'translate(' + offsetX + 'px,' + offsetY +'px);display: block;left:0px;top:0px;'

              }
          },
          handleMouseEnter: function () {
              data.zoomedImg.element.style.display = 'block';
              data.zoomLens.element.style.display = 'block';

          },
          handleMouseLeave: function () {
              data.zoomedImg.element.style.display = 'none';
              data.zoomLens.element.style.display = 'none';
          },
          handleScroll: function () {
              offset = getOffset(data.sourceImg.element);
          }
      };

      // Setup/Initialize library
      setup();

      if (data.sourceImg.element.complete) {
          onSourceImgLoad();
      } else {
          data.sourceImg.element.onload = onSourceImgLoad;
      }

      return {
          setup: function () {
              setup();
          },
          kill: function () {
              kill();
          },
          _getInstanceInfo: function () {
              return {
                  setup: setup,
                  kill: kill,
                  onSourceImgLoad: onSourceImgLoad,
                  data: data,
                  options: options
              }
          }
      }
  }
}));

const radios = document.querySelectorAll("[data-option-radio]");
const selects = document.querySelectorAll("[data-option-select]");
const main = document.querySelector("[data-option-main]");

const selectors = document.querySelectorAll("[data-option-selector]")

let selected = [];

const add_to_cart_button = document.querySelector(".js-add-to-cart");
const sold_out = document.querySelector(".js-sold-out");

// Function to get current variants JSON (re-reads from DOM each time)
function getVariantsJson() {
  const variantsElement = document.querySelector(".js-variants-json");
  if (!variantsElement) {
    console.warn('Variants JSON element not found');
    return [];
  }
  try {
    return JSON.parse(variantsElement.innerHTML);
  } catch (e) {
    console.error('Error parsing variants JSON:', e);
    return [];
  }
}

// Initialize variants_json (will be re-read when product changes)
let variants_json = getVariantsJson();

// Function to refresh variants JSON (call this when product changes)
window.refreshVariantsJson = function() {
  variants_json = getVariantsJson();
  console.log('Variants JSON refreshed, count:', variants_json.length);
};

async function getProductImages() {

  const el = document.querySelector('.js-product')
  const handle = el.dataset.handle

  // get the product data, using the values
  const product = await fetch(`/products/${handle}.json`)
    .then(response => response.json())
    .then(data => { return data.product });
  
  return getImages(product)
}

(async () => {

  // get images once
  const images = await getProductImages()

  // set the images to init
  updateImages()
  updateVariantImages()

  // Helper function to reset size selection when color changes
  function resetSizeForColor() {
    // Get the selected color (position 1)
    const colorSelector = document.querySelector('[data-option-position="1"][data-option-selector]:checked');
    if (!colorSelector) {
      return false; // No color selected
    }
    
    const selectedColor = colorSelector.value;
    console.log('Color changed to:', selectedColor);
    
    // Get currently selected size (position 2)
    const currentSizeSelector = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
    
    // Check if current size is available for the new color
    if (currentSizeSelector) {
      const currentSize = currentSizeSelector.value;
      const testVariant = variants_json.find(v => {
        // Try using option1/option2 first (more reliable)
        if (v.option1 && v.option2) {
          return v.option1 === selectedColor && v.option2 === currentSize;
        }
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        return titleParts[0] === selectedColor && titleParts[1] === currentSize;
      });
      
      if (testVariant) {
        console.log('Current size', currentSize, 'is available for color', selectedColor);
        return false; // Size is valid, no need to reset
      }
    }
    
    // Current size is not available (or no size selected), find first available size for this color
    console.log('Resetting size selection for color:', selectedColor);
    const availableSizes = [];
    
    // Find all sizes available for this color
    variants_json.forEach(v => {
      let sizeValue = null;
      // Try using option1/option2 first (more reliable)
      if (v.option1 && v.option2) {
        if (v.option1 === selectedColor) {
          sizeValue = v.option2;
        }
      } else {
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        if (titleParts[0] === selectedColor && titleParts[1]) {
          sizeValue = titleParts[1];
        }
      }
      
      if (sizeValue && !availableSizes.includes(sizeValue)) {
        availableSizes.push(sizeValue);
      }
    });
    
    // Uncheck all size radios
    document.querySelectorAll('[data-option-position="2"][data-option-selector]').forEach(radio => {
      radio.checked = false;
    });
    
    // Select the first available size
    if (availableSizes.length > 0) {
      const firstSize = availableSizes[0];
      const firstSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector][value="' + firstSize + '"]');
      if (firstSizeRadio) {
        firstSizeRadio.checked = true;
        console.log('Auto-selected size:', firstSize, 'for color:', selectedColor);
        return true; // Size was reset
      }
    }
    
    console.warn('No available sizes found for color:', selectedColor);
    return false;
  }

  // set selectors - attach change listeners
  console.log('Setting up change listeners for', selectors.length, 'selectors');
  for (const selector of selectors) {
    console.log('Attaching listener to:', selector, 'Value:', selector.value, 'Checked:', selector.checked);
    selector.addEventListener('change', function() {
      console.log('=== CHANGE EVENT FIRED ===');
      console.log('Selector:', this);
      console.log('Value:', this.value);
      console.log('Checked:', this.checked);
      
      // Check if this is a color change (position 1)
      const position = this.getAttribute('data-option-position');
      if (position === '1') {
        console.log('Color change detected, resetting size if needed...');
        // Reset size selection if needed
        const sizeWasReset = resetSizeForColor();
        if (sizeWasReset) {
          // Trigger change event on the newly selected size radio
          const newSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
          if (newSizeRadio) {
            // Use a small delay to ensure the color change is processed first
            setTimeout(() => {
              newSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }, 10);
          }
        }
      }
      
      // Get the selected variant
      const selected_variant = window.getSelectedVariant();
      console.log('Selected variant:', selected_variant);
      
      if (selected_variant) {
        console.log('Calling updateSelection...');
        // Update selection (this will update text, price, images, and size button styles)
        window.updateSelection(selected_variant);
        console.log('updateSelection called');
      } else {
        console.warn('No variant found! Checked selectors:', document.querySelectorAll('[data-option-selector]:checked'));
        // If no variant found and color was just changed, try to find any variant with the selected color
        if (position === '1') {
          const colorValue = this.value;
          const firstVariantForColor = variants_json.find(v => {
            // Try using option1 first (more reliable)
            if (v.option1) {
              return v.option1 === colorValue;
            }
            // Fallback to title parsing
            const titleParts = v.title.split(' / ');
            return titleParts[0] === colorValue;
          });
          if (firstVariantForColor) {
            console.log('Found first variant for color:', firstVariantForColor);
            // Update the main select to match this variant - re-query from DOM
            const mainSelect = document.querySelector("[data-option-main]");
            if (mainSelect) {
              mainSelect.value = firstVariantForColor.id;
            }
            if (main) {
              main.value = firstVariantForColor.id;
            }
            window.updateSelection(firstVariantForColor);
          }
        }
      }
    }, false); // Use bubble phase, not capture
  }
  
  // Also attach to all radios with data-option-selector as a backup
  document.querySelectorAll('[data-option-selector]').forEach(function(radio) {
    if (!radio.hasAttribute('data-listener-attached')) {
      radio.setAttribute('data-listener-attached', 'true');
      radio.addEventListener('change', function() {
        console.log('=== BACKUP CHANGE EVENT FIRED ===');
        console.log('Radio:', this);
        
        // Check if this is a color change (position 1)
        const position = this.getAttribute('data-option-position');
        if (position === '1') {
          console.log('Backup: Color change detected, resetting size if needed...');
          const sizeWasReset = resetSizeForColor();
          if (sizeWasReset) {
            // Trigger change event on the newly selected size radio
            const newSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
            if (newSizeRadio) {
              setTimeout(() => {
                newSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }, 10);
            }
          }
        }
        
        const selected_variant = window.getSelectedVariant();
        if (selected_variant && typeof window.updateSelection === 'function') {
          window.updateSelection(selected_variant);
        } else if (position === '1') {
          // If no variant found and color was just changed, try to find any variant with the selected color
          const colorValue = this.value;
          const firstVariantForColor = variants_json.find(v => {
            // Try using option1 first (more reliable)
            if (v.option1) {
              return v.option1 === colorValue;
            }
            // Fallback to title parsing
            const titleParts = v.title.split(' / ');
            return titleParts[0] === colorValue;
          });
          if (firstVariantForColor && typeof window.updateSelection === 'function') {
            console.log('Backup: Found first variant for color:', firstVariantForColor);
            const mainSelect = document.querySelector("[data-option-main]");
            if (mainSelect) {
              mainSelect.value = firstVariantForColor.id;
            }
            if (main) {
              main.value = firstVariantForColor.id;
            }
            window.updateSelection(firstVariantForColor);
          }
        }
      });
    }
  });
  
  window.getSelectedVariant = function() {
    // Re-query selectors in case DOM was updated
    const currentSelectors = document.querySelectorAll("[data-option-selector]");
    selected = [];
  
    for (const selector of currentSelectors) {
      if (selector.hasAttribute('data-option-radio')) {
        if (selector.checked) {
          selected.push(selector.value)
        }
      } else if (selector.hasAttribute('data-option-select')) {
        selected.push(selector.value)
      }
    }
  
    // Get fresh variants JSON
    const currentVariantsJson = getVariantsJson();
    
    if (selected.length === 0) {
      console.warn('No options selected');
      return null;
    }
  
    const selected_title = selected.join(" / ");
    console.log('Looking for variant with title:', selected_title);
    console.log('Available variants:', currentVariantsJson.map(v => v.title));
    
    // Try exact title match first
    let selected_variant = currentVariantsJson.find(e => (e.title == selected_title));
    
    // If not found, try using option1/option2 matching (more reliable)
    if (!selected_variant && selected.length >= 2) {
      selected_variant = currentVariantsJson.find(v => {
        // Try using option1/option2 if available
        if (v.option1 && v.option2) {
          return v.option1 === selected[0] && v.option2 === selected[1];
        }
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        return titleParts[0] === selected[0] && titleParts[1] === selected[1];
      });
    }
    
    if (!selected_variant) {
      console.warn('Variant not found for:', selected_title, 'Selected values:', selected);
    }
  
    return selected_variant;
  }
  
  window.updateSelection = function(selected_variant) {
    console.log('updateSelection called with variant:', selected_variant);
    
    // change main value - re-query from DOM in case element was replaced
    const mainSelect = document.querySelector("[data-option-main]");
    if (mainSelect) {
      mainSelect.value = selected_variant.id;
      console.log('Updated main select value to:', selected_variant.id);
    } else {
      console.warn('Main select element not found');
    }
    
    // Also update the cached main variable for backward compatibility
    if (main) {
      main.value = selected_variant.id;
    }
  
    // change images - wrap in try-catch so errors don't break the rest
    try {
      updateVariantImages();
    } catch (error) {
      console.warn('Error updating variant images:', error);
      // Continue with other updates even if image update fails
    }
  
    // Update size button styles immediately
    if (typeof window.updateSizeButtonStyles === 'function') {
      window.updateSizeButtonStyles();
    }
  
    // update option names - use variant's option properties (option1, option2, option3) which are most reliable
    setTimeout(function() {
      console.log('Updating option text for variant:', selected_variant);
      
      // Build map of position -> value from variant's option properties
      const selectedValuesByPosition = {};
      
      // Use option1, option2, option3 if available (most reliable)
      if (selected_variant.option1) {
        selectedValuesByPosition['1'] = selected_variant.option1;
      }
      if (selected_variant.option2) {
        selectedValuesByPosition['2'] = selected_variant.option2;
      }
      if (selected_variant.option3) {
        selectedValuesByPosition['3'] = selected_variant.option3;
      }
      
      console.log('Selected values by position:', selectedValuesByPosition);
      
      // Fallback: parse from variant title if option properties aren't available
      if (Object.keys(selectedValuesByPosition).length === 0 && selected_variant.title) {
        const variantTitleParts = selected_variant.title.split(' / ').map(function(part) {
          return part.trim();
        });
        variantTitleParts.forEach(function(part, index) {
          selectedValuesByPosition[(index + 1).toString()] = part;
        });
      }
      
      // Update each option label with the selected value for its position
      document.querySelectorAll('[data-option-label]').forEach(function(optionLabel) {
        const position = optionLabel.getAttribute('data-option-position');
        const optionName = optionLabel.getAttribute('data-option-name');
        const optionTextElement = optionLabel.querySelector('.js-option');
        
        if (position && optionTextElement) {
          const selectedValue = selectedValuesByPosition[position];
          if (selectedValue) {
            optionTextElement.textContent = selectedValue;
            console.log('Updated option text - Position:', position, 'Name:', optionName, 'Value:', selectedValue);
          } else {
            // Last resort: try to get from checked radio
            const checkedRadio = document.querySelector('input[type="radio"][data-option-position="' + position + '"]:checked');
            if (checkedRadio) {
              const value = checkedRadio.getAttribute('data-option-value') || checkedRadio.value;
              if (value) {
                optionTextElement.textContent = value;
                console.log('Updated option text from radio - Position:', position, 'Name:', optionName, 'Value:', value);
              }
            }
          }
        }
      });
      
      // Fallback: if no data-option-label elements found, update first .js-option
      if (document.querySelectorAll('[data-option-label]').length === 0) {
        const firstOption = document.querySelector('.js-option');
        if (firstOption) {
          firstOption.textContent = selected_variant.title;
        }
      }
    }, 100); // Increased delay to ensure DOM is fully updated
  
    // update pricing
    document.querySelector(".js-variant-price").innerHTML =
      selected_variant.price;
  
    document.querySelector(".js-variant-compare-price").innerHTML =
      selected_variant.compare_at_price;
  
    // if not available, let them know
    if (selected_variant.available == "true") {
      add_to_cart_button.style.display = "block";
      sold_out.style.display = "none";
    } else {
      add_to_cart_button.style.display = "none";
      sold_out.style.display = "block";
    }
  
    // Update size button styles after variant selection
    // Check if the function exists (it's defined in product.liquid)
    if (typeof window.updateSizeButtonStyles === 'function') {
      // Call immediately to update green border indicator
      window.updateSizeButtonStyles();
      // Call again after a short delay to ensure it catches all updates
      setTimeout(window.updateSizeButtonStyles, 100);
    }
  
  }
  
  function updateVariantImages() {  
    if (!main || !images || images.length === 0) {
      console.warn('Cannot update variant images - missing main or images');
      return;
    }
    
    const current_variant_id = main.value;
    const current_images = images.filter(e => (e.variant_id == current_variant_id));
    
    if (current_images.length === 0 || !current_images[0] || !current_images[0].src) {
      console.warn('No images found for variant:', current_variant_id);
      return;
    }
    
    jQuery('.js-thumbnail img').each(function() { 
      if ((jQuery(this).attr('src')) == current_images[0].src) { 
        jQuery(this).parent().click(); 
      } 
    });
  }
  
  function updateImages() {
  
    unsetSlider(); 

    const current_variant_id = main.value

    // get images by variant
    const current_images = images.filter((v,i,a)=>a.findIndex(v2=>(v2.src===v.src))===i)
  
    updateThumbnails(current_images)
    updateMainImages(current_images)

  
    addArrows();

    setSlider();
    setNav();

    revealImageBlock();
  
  }

  function revealImageBlock() {
    document.querySelector('.js-block').style.opacity = 1
  }
  
  function setNav() {
    jQuery('.js-thumbnail').click(function () {
      let slideIndex = jQuery(this).index();
      console.log(slideIndex)
      jQuery('.js-images').slick('slickGoTo', parseInt(slideIndex))
    })
  }
  
  function addArrows() {
    let arrows =
      `
      <button class='js-next transition duration-500 p-2 md:p-8 outline-none z-20 absolute right-0 top-1/2 transform -translate-y-1/2' aria-label='Next Image'>
        <svg width="14px" height="27px" viewBox="0 0 14 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-1378.000000, -494.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(1339.454545, 13.545455) rotate(-90.000000) translate(-1339.454545, -13.545455) translate(1326.454545, 6.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 11.3033954 0.973568282 0.525739321 0 1.41949617 12.7136564 13.0909091 26 0.893756846"></polygon></g></g></g></g></g></svg>
      </button>
      <button class='js-prev transition duration-500 p-2 md:p-8 outline-none z-20 absolute left-0 top-1/2 transform -translate-y-1/2' aria-label='Previous Image'>
        <svg width="15px" height="27px" viewBox="0 0 15 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-48.000000, -496.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(8.545455, 15.128788) rotate(-270.000000) translate(-8.545455, -15.128788) translate(-4.454545, 7.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 12.245345 0.973568282 0.569550931 0 1.53778751 12.7136564 14.1818182 26 0.968236583"></polygon></g></g></g></g></g></svg>
      </button>
      `
  
    document.querySelector('.js-arrows').innerHTML = arrows;
  }
  
  function unsetSlider() {
    if (jQuery('.js-images').hasClass('slick-initialized')) {
      jQuery('.js-images').slick('unslick');
    }
  }
  
  
  function setSlider() {
  
    jQuery('.js-images').slick({
      dots: false,
      arrows: true,
      fade: true,
      nextArrow: jQuery('.js-next'),
      prevArrow: jQuery('.js-prev'),
      accessibility: false,
      ariaLive: 'off'
    });
  }
  

  
  function updateThumbnails(images) {
  
    let thumbnail_images_block = ''
  
    if (images) {
      for (let thumbnail_image of images) {
        let thumbnail_image_block = `
        <div class='w-full pt-120 relative mb-4 js-thumbnail'>
          <img src='${thumbnail_image.src}' alt='' class='w-full h-full inset-0 absolute object-contain'>
        </div>
      `
        thumbnail_images_block += thumbnail_image_block
      }
    }
  
    document.querySelector('.js-thumbnails').innerHTML = thumbnail_images_block;
  }
  
  function updateMainImages(images) {

    let main_images_block = ''
  
    if (images) {
      for (let main_image of images) {
        let main_image_block = `
          <div>
            <div class='js-zoomx zoom-image'>
              <img class='block z-20 w-full' src='${main_image.src}' alt='' />
            </div>
          </div>
        `
        main_images_block += main_image_block
      }
  
    }
  
    document.querySelector('.js-images').innerHTML = main_images_block;
  
    var options = {
      fillContainer: true,
      zoomPosition: 'original'
    };

    const zoom_images = document.querySelectorAll('.js-zoom')

    let zoom_array = []

    for (const zoom_image of zoom_images) {
      zoom_array.push(new ImageZoom(zoom_image, options));
    }

    window['imagezoom'] = zoom_array

    window.addEventListener('resize', () => {
      
      const zoom_images = window['imagezoom']

      if (zoom_images) {
        for (const zoom_image of zoom_images) {
          if (zoom_image) {
            zoom_image.kill()
          }
        }
      }

      delete window['imagezoom'];
    });

  }



})()




// function getFeaturedImages() {
//   let product = JSON.parse(document.querySelector('.js-product-json').innerHTML)
//   let variants = product.variants
//   let images = product.images

//   let featured_images = []

//   for (let variant of variants) {
//     if (variant.featured_image) {
//       let obj = {
//         src: variant.featured_image.src,
//         variant_id: variant.featured_image.variant_ids[0],
//       }
//       featured_images.push(obj)
//     }
//   }


//   if (featured_images.length == 0) {
//     return [];
//   }


//   let new_images = {}
//   let variant_id = ''

//   for (let image of images) {
//     for (let featured_image of featured_images) {
//       let featured_image_without_https = featured_image['src'].replace('https:', '')
//       if (featured_image_without_https == image) {
//         variant_id = featured_image.variant_id
//       }
//     }

//     if (new_images[variant_id] == undefined) {
//       new_images[variant_id] = []
//     }
//     new_images[variant_id].push(image)
//   }  

//   return new_images;
// }

// function getImages() {
//   let product = JSON.parse(document.querySelector('.js-product-json').innerHTML)
//   return product.images
// }